<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="false" />
        <div style="min-height: 900px;">
            <img src="../assets/404.png" style="width: 561px; height: 334px; display: block; margin: 80px auto;" alt="" />
            <div class="txt1">哎哟，页面不小心走丢了~</div>
            <div style="margin: 40px auto;width: 25%;">
                <div class="but1" @click="to_index">返回首页</div>
                <div class="but1" @click="page_back" style="float: right;">返回上一级</div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import swiperRight from '../public/swiper_right';
export default {
    name: 'index',
    components: {
        htmlHeader,
        foot,
        swiperRight
    },
    data() {
        return {};
    },
    methods: {
        to_index() {
            this.$router.push('/');
        },
        page_back() {
            this.$router.go(-1);
        }
    },
    created() {}
};
</script>
<style scoped>
.but1 {
    width: 140px;
    height: 40px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    float: left;
    cursor: pointer;
}
.txt1 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    text-align: center;
    margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/404.vue